// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"061394a1","977":"1a6e419b"}[chunkId] + ".chunk.js";
};